import {Injectable} from '@angular/core';
import {ApiService} from '../api/api.service';
import {Observable} from 'rxjs/Rx';
import { Cacheable } from 'ts-cacheable';
import { CACHE_KEYS } from 'src/app/helpers/Cache';

@Injectable({
    providedIn: 'root'
})
export class FlipCardsService {

    constructor(private api: ApiService) {}

    // maxAge 30 minutes
    @Cacheable({ cacheKey: CACHE_KEYS.flipcards, maxAge: 30 * 60 * 1000 })
    public getFlipCards(body): Observable<any> {
        return this.api.post('/flipcards', {
            body: body
        });
    }

}
